<template>
    <div>
        <div id="gym-detail-header-wrap">
            <div class="gym-header-wrap" :class="scrollCheck ? 'active' : ''">
                <div class="back-btn" @click="$router.back()">
                    <span></span>
                </div>
                <div class="gym-title" v-show="scrollCheck">
                    <p>{{gym.gymName}}</p>

                </div>
                <div class="share-btn" @click="shareModalShow = true">
                    <span/>
                </div>
            </div>
        </div>

        <share-modal :show="shareModalShow" v-show="shareModalShow" @close="shareModalShow = false"
                     @kakao="kakaoShare(gym.gymName, '오마이플레이에서 체육관을 공유합니다', gym.imageList ? gym.imageList[0].imagePath : null)"
                     @band="bandShare(gym.gymName)" @kakaoStory="kakaoStoryShare(`${gym.gymName}를 오마이플레에서 공유합니다`)"
                     @facebook="facebookShare" @link="copyLink"></share-modal>
        <AlertModal v-show="linkCopySuccessAlertShow" @close="linkCopySuccessAlertShow=false" title="알림"
                    content="링크 복사가 완료되었습니다"></AlertModal>
        <AlertModal v-show="linkCopyErrorAlertShow" @close="linkCopyErrorAlertShow=false" title="알림"
                    content="링크 복사가 실패되었습니다. 잠시 후 시도해주세요"></AlertModal>
    </div>

</template>
<script>

    import ImageSlider from "../../main/ImageSlider";
    import {mapState} from 'vuex'
    import shareMixin from "../../../mixins/shareMixin";

    export default {
        computed: {
          ...mapState('gyms', ['gym'])
        },
        mixins: [shareMixin],
        props: ['scroll_check'],
        components: {ImageSlider},
        data() {
            return {
                imageSrc: ['../../images/gym_sample.png', '../../images/gym_sample2.png'],
                scrollCheck: this.scroll_check,
                shareModalShow: false,
                shareType: -1
            }
        },
        watch: {
          scroll_check: function(newVal){
              this.scrollCheck = newVal
          }
        }
    }
</script>
